import { RefObject, useRef, useState } from 'react';
import PagesAccordionItem from '@features/pages/components/PagesAccordion/PagesAccordionItem';
import PagesAccordionHeader from '@features/pages/components/PagesAccordion/PagesAccordionHeader';
import { IAccordion, ICategoryLabelBlock, IContentAccordion, IItemAccordion } from '@features/pages/typescript';
import styles from '@features/pages/components/PagesAccordion/PagesAccordion.styles';
import { ICmsContent } from '@features/cms/typescript';
import CategoryLabelBlock from '@features/cms/components/categories/CategoryLabelBlock/CategoryLabelBlock';
import theme from '@styles/theme';
type PropsType = {
  block: IAccordion | ICmsContent;
  defaultBackground?: string;
  isFirst?: boolean;
};
const PagesAccordion = ({
  block,
  defaultBackground = theme.rawColors.neutralWhite,
  isFirst = false
}: PropsType) => {
  const {
    data,
    blockAppearance,
    code,
    headerBlock
  } = block as IAccordion;
  const prevPagesAccordionItemContent = useRef<HTMLDivElement | null>(null);
  const initialActiveAccordion = Object.keys(data.accordions)[0] === 'promoLabel' ? 1 : 0;
  const background = blockAppearance?.background || defaultBackground;
  const [activeAccordion, setActiveAccordion] = useState<number[] | null>([initialActiveAccordion]);
  const handleDescriptionItemClick = (index: number, childrenRef: RefObject<HTMLDivElement | null>) => {
    setActiveAccordion(activeAccordion?.includes(index) ? activeAccordion.filter(item => item !== index) : [...(activeAccordion ?? []), index]);
    prevPagesAccordionItemContent.current = childrenRef.current;
  };
  const labelBlock = Object.keys(data.accordions).map(name => {
    const test = Object.values(data.accordions[name] as IContentAccordion).find((item: IContentAccordion) => {
      if (item.code === 'labelBlock') {
        return true;
      }
      return false;
    }) as IContentAccordion;
    return test ? test.data as ICategoryLabelBlock : null;
  }).filter(el => el);
  const renderContent = (accordions: IItemAccordion) => Object.keys(accordions).map((name, index) => {
    if (accordions[name]?.labelBlock) {
      return null;
    }
    return <section id={code} key={`${code}-${name}-${index}`} data-testid={code}>
          <PagesAccordionItem id={`accordionItem-${index}`} header={name} defaultBackground={background} accordionItem={accordions[name]} isOpen={activeAccordion?.includes(index) ?? false} childrenRef={activeAccordion?.includes(index) ? prevPagesAccordionItemContent : null} onClick={childrenRef => handleDescriptionItemClick(index, childrenRef)} isFirst={isFirst && !index} />
        </section>;
  });
  return <div sx={styles.newAccordionContainer(background)} data-testid="pages-accordion-container">
      {labelBlock && labelBlock[0] && <CategoryLabelBlock data={labelBlock[0]} isFirst={false} />}
      {headerBlock && <PagesAccordionHeader data={headerBlock} isFirst={isFirst} />}
      <div sx={styles.contentWrapper}>{renderContent(data.accordions)}</div>
    </div>;
};
export default PagesAccordion;